import { Button, Input, Modal, Switch } from 'antd';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

const ASSET_UPLOAD_MODAL_TITLE = 'Upload Asset';

const PropertyModal = styled(Modal)`
    .last-form-item {
        margin-bottom: 0px;
    }
`;

const SwitchContainer = styled.span`
    width: 111px;
    float: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
`;

const FileInput = styled.span`
    width: 100%;
    display: flex;
    justify-content: left;
    flex-wrap: nowrap;
    margin-bottom: 10px;
`;

const FileNameInput = styled(Input)`
    flex-grow: 1;
`;

const UploadElement = styled.input`
    display: none;
    width: 100px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: white;
`;

function UploadAssetModal() {
    const store_creative = store.creative;
    const uploadManager = store_creative?.assets.uploadManager;
    const modalVisible = uploadManager?.modalVisible;
    const uploadRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!modalVisible && uploadRef.current) {
            uploadRef.current.value = '';
        }
    }, [modalVisible]);

    if (!store_creative || !uploadManager) return null;

    const canConfirm = !!uploadManager.file;

    const handleCancel = () => {
        void uploadManager.hideModalAndReset();
    };

    return (
        <PropertyModal
            title={ASSET_UPLOAD_MODAL_TITLE}
            open={uploadManager.modalVisible}
            confirmLoading={uploadManager.loading}
            onCancel={handleCancel}
            footer={
                <>
                    <SwitchContainer>
                        Optimize
                        <Switch
                            checked={uploadManager.optimize}
                            onChange={(checked) =>
                                (uploadManager.optimize = checked)
                            }
                        />
                    </SwitchContainer>

                    <Button onClick={handleCancel}>Cancel</Button>

                    <Button
                        disabled={!canConfirm}
                        type="primary"
                        loading={uploadManager.loading}
                        onClick={() => uploadManager.upload()}
                    >
                        {uploadManager.isUpdate ? 'Update' : 'Add'}
                    </Button>
                </>
            }
        >
            <UploadElement
                type="file"
                className="file-select"
                ref={uploadRef}
                onChange={(e) => {
                    if (e.target.files && e.target.files.length === 1) {
                        uploadManager.file = e.target.files[0];
                    }
                }}
            />
            <FileInput>
                <FileNameInput
                    placeholder="Select a file from your computer"
                    disabled
                    value={uploadManager.fileName}
                />
                <Button
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                        uploadRef.current?.click();
                    }}
                >
                    Browse
                </Button>
            </FileInput>
        </PropertyModal>
    );
}

export default observer(UploadAssetModal);
